import { baseApi as api } from "@/request/viewgres_v4";
import qs from "qs";

let baseUrl = "/products/models";

// 获取产品颜色的分页列表
export function GetProductModelList(params = { page: 0, size: 20 }) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `${baseUrl}?${qs.stringify(params, {
          arrayFormat: "repeat"
        })}`
      )
      .then(res => {
        if (res.status === 200 || res.status === 206) {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 根据id获取具体的产品型号
export function GetProductModelById(id = null) {
  return new Promise((resolve, reject) => {
    api
      .get(`${baseUrl}/${id}`)
      .then(res => {
        if (res.status === 200) {
          resolve(res);
        }
      })
      .catch(err => {
        reject(err);
      });
  });
}
